import { WIDGET_TYPO_CLS } from "@/lib/sayz-widget-tokens";

/** Karşılama'da bilinen alanları listeleyen kompakt chip grubu.
 *  Bg'li ama minimal — küçük font, dar padding.
 *  `highlightedKey` verildiyse o chip dark-highlighted (yeni cevap sinyali).
 *  `centered` verildiyse header ve chip'ler yatay olarak ortalanır. */
export const ProfileChipList = ({ chips, highlightedKey, centered = false }) => (
    <div className={`space-y-2 ${centered ? "w-full" : ""}`}>
        <div className={`flex items-center gap-2 ${centered ? "justify-center" : ""}`}>
            <span className="text-[10px] font-medium uppercase tracking-wider text-muted-foreground/80">
                Bildiklerimiz ({chips.length})
            </span>
        </div>
        <div className={`flex flex-wrap gap-1 ${centered ? "justify-center" : ""}`}>
            {chips.map((c, i) => {
                const isHighlighted = c.key === highlightedKey;
                return (
                    <span
                        key={c.key}
                        className={`inline-flex items-baseline gap-1 rounded-md px-2 py-0.5 ${WIDGET_TYPO_CLS.body} leading-tight sayz-fms-chip transition-colors ${
                            isHighlighted
                                ? "bg-foreground text-background"
                                : "bg-muted/60 text-foreground"
                        }`}
                        style={{ animationDelay: `${180 + i * 35}ms` }}
                        data-testid={`fms-welcome-chip-${c.key}`}
                        data-highlighted={isHighlighted || undefined}
                    >
                        <span className={isHighlighted ? "text-background/65" : "text-muted-foreground/75"}>
                            {c.label}
                        </span>
                        <span className="font-semibold tabular-nums">{c.value}</span>
                    </span>
                );
            })}
        </div>
    </div>
);
